<template>
  <div>
    <!--  -->
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      @handleSelectionChange="handleSelectionChange"
      @delBtn="delBtn"
      @refresh-change="getlist"
      @refreshBtn="refreshBtn"
    ></zx-table>
    <ele-form-dialog
      v-model="formData"
      :formDesc="formDesc"
      :request-fn="handleSubmit"
      :rules="rules"
      labelPosition="left"
      :form-attrs="{ size: 'small' }"
      :dialogAttrs="{
        center: false,
        'destroy-on-close': true,
        'custom-class': 'formD'
      }"
      v-dialogdrag
      :visible.sync="dialogFormVisible"
      @request-success="handleSuccess"
      :title="table.title"
    />
  </div>
</template>

<script>
import * as scenic from "@/api/product/scenic.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    const _ = this;
    return {
      scenic_id: "",
      formData: {},
      formDesc: {},
      add: {
        // title: "title",
        title: {
          label: "景区名称",
          type: "input"
        },
        // thumb: "thumb",
        thumb: {
          label: "缩略图",
          type: "image-uploader",
          attrs: {
            size: 100,
            accept: "jpg,jpeg,png",
            action: this.$uploadURL,
            headers: {
              authorization: sessionStorage.getItem("token")
            },
            responseFn(response, file) {
              if (response.code !== 200) {
                this.$message.error(response.msg);
              }
              // 根据响应结果, 设置 URL
              return response.data.url;
            },
            lazy: true,
            fileSize: 1
          },
          layout: 24
        },
        // describe: "describe",
        // price: 100,
        theater_code: {
          label: "剧院编码",
          type: "input",
          layout: 12
        },
        price: {
          label: "价格",
          type: "input",
          layout: 12
        },
        // number: 100,
        number: {
          label: "已售数",
          type: "input",
          layout: 12
        },
        platform: {
          label: "销售平台",
          type: "checkbox",
          layout: 18,
          options: [
            {
              text: "微信",
              value: "weixin"
            },
            {
              text: "抖音",
              value: "toutiao"
            },
            {
              text: "支付宝",
              value: "alipay"
            }
          ]
        },
        kf: {
          label: "客服电话",
          type: "input",
          layout: 18
        },
        // status: 0
        status: {
          label: "状态",
          type: "radio",
          default: 1,
          options: [
            {
              text: "启用",
              value: 1
            },
            {
              text: "禁用",
              value: -1
            }
          ],
          layout: 12
        },
        // gis: "gis",
        gis: {
          label: "坐标",
          type: "gmap", // 只需要在这里指定为 bmap 即可
          // 组件属性, 具体参考下面 Props 部分
          attrs: {
            ak: "YOUR_APP_KEY",
            zoom: 15
          },
          isScrollWheelZoom: true
          // displayFormatter: address => {
          //   // 设置显示的值
          //   if (typeof address === "string") {
          //     return {
          //       address: address,
          //       lat: this.formData.latitude,
          //       lng: this.formData.longitude
          //     };
          //   } else {
          //     return address;
          //   }
          // }
        },
        address: {
          label: "地址",
          type: "input"
        },
        description: {
          label: "简介",
          type: "quill-editor",
          attrs: {
            // 上传相关
            action: this.$uploadURL, // 上传地址
            // data: { token: "xxx" },
            headers: {
              authorization: sessionStorage.getItem("token")
            },
            // 对响应结果进一步处理
            responseFn(response, file) {
              if (response.code !== 200) {
                this.$message.error(response.msg);
              }
              // 根据响应结果, 设置 URL
              return response.data.url;
            },
            // 编辑器相关属性
            placeholder: "请输入..."
          }
        }
      },
      info: {
        images: {
          label: "图集",
          type: "image-uploader",
          attrs: {
            // drag: true, // 多张
            multiple: true,
            size: 100,
            accept: "jpg,jpeg,png",
            action: this.$uploadURL,
            headers: {
              authorization: sessionStorage.getItem("token")
            },
            responseFn(response, file) {
              if (response.code !== 200) {
                this.$message.error(response.msg);
              }
              // 根据响应结果, 设置 URL
              return response.data.url;
            },
            lazy: true
          },
          layout: 24
        },
        course: {
          label: "介绍",
          type: "textarea",
          layout: 24
        },

        prompt: {
          label: "演出时间提示",
          type: "textarea"
        },
        pre: {
          label: "预定须知",
          type: "quill-editor",
          attrs: {
            // 上传相关
            action: this.$uploadURL, // 上传地址
            // data: { token: "xxx" },
            headers: {
              authorization: sessionStorage.getItem("token")
            },
            // 对响应结果进一步处理
            responseFn(response, file) {
              _.messageShow();

              // if (response.code !== 200) {
              //   this.$message.error(response.msg);
              // }
              // // 根据响应结果, 设置 URL
              // return response.data.url;
            },
            // 编辑器相关属性
            placeholder: "请输入..."
          }
        },
        policy: {
          label: "温馨提示",
          type: "textarea",
          placeholder: "内容将以弹窗形式展示,为空时则不提示..."
        }
      },
      rules: {},
      dialogFormVisible: false,
      submitType: 1,
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 25,
        pageSizes: [15, 25, 30, 40, 50, 100],
        // sizes, prev, pager, next, jumper, ->, total, slot
        // "layout":"prev, pager, next",
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "景区",
        // 表格底部按钮
        btnBottom: false,
        // 操作按钮列定位 默认:false;
        fixed: false,
        // 子表格 默认: ; 数据格式:String;<对应子行字段名称>
        children: "children",
        // 多选 默认:false;
        // selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: false,
        // 表格高度 默认:100%; 数据格式:Number;
        // height:500,
        // 数边框 默认:false;
        border: false,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: false,
        // 删除  默认:true;
        delBtn: true,
        // 折叠筐 默认:false;
        expand: false,
        column: [
          {
            prop: "title",
            label: "景区名称",
            type: "input",
            hide: true
          },

          {
            prop: "thumb",
            label: "缩略图",
            type: "textarea",
            show: "image",
            hide: true
          },

          {
            prop: "kf",
            label: "客服电话",
            type: "textarea",
            show: "img",
            hide: true
          },
          {
            prop: "address",
            label: "地址",
            type: "textarea",
            show: "img",
            hide: true
          },
          {
            layout: 12,
            prop: "status",
            label: "状态",
            type: "radio",
            show: "tag",
            default: 0,
            tagtype: [
              {
                text: "启用",
                type: "success",
                value: 1
              },
              {
                text: "禁用",
                type: "danger",
                value: -1
              }
            ],
            hide: true
          },

          {
            prop: "create_time",
            label: "创建时间",
            type: "input",
            hide: true,
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: false,
            // 该字段是否可以修改默认true
            editDisplay: false
          }
        ],
        btnNavLeft: [
          {
            text: "添加",
            size: "mini",
            type: "success",
            click: () => {
              this.formData = {};
              this.formDesc = this.add;
              this.submitType = 1;
              this.dialogFormVisible = true;
            }
          }
        ],
        btnList: [
          {
            name: "编辑",
            size: "mini",
            type: "text",
            click: (id, row, index) => {
              this.formDesc = this.add;
              this.formData = row;
              this.submitType = 2;
              this.dialogFormVisible = true;
            }
          },
          {
            name: "详情",
            size: "mini",
            type: "text",
            click: (id, row, index) => {
              this.$router.push({
                path: "/product/scenic/" + row.scenic_id,
                query: { title: row.title, id: row.scenic_id }
              });
            }
          },
          {
            name: "门票",
            size: "mini",
            type: "text",
            click: (id, row, index) => {
              this.$router.push({
                path: "/product/ticket/" + row.scenic_id,
                query: { title: row.title, id: row.scenic_id }
              });
            }
          },
          {
            name: "信息设置",
            size: "mini",
            type: "text",
            click: (id, row, index) => {
              let that = this;
              this.formDesc = this.info;
              that.dialogFormVisible = true;
              this.scenic_id = row.scenic_id;
              scenic.getScenicInfo.r({ id: row.scenic_id }).then(res => {
                if (res.info) {
                  this.formData = res.info;
                }
                this.submitType = 3;
              });
            }
          }
        ]
      },
      tableData: []
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    messageShow() {
      this.$message.error(
        "目前《预定须知》不支持图片，如有需要请联系，系统管理员"
      );
      // Message({
      //   message: "目前《预定须知》不支持图片，如有需要请联系，系统管理员",
      //   type: "error",
      //   duration: 3 * 1000
      // });
    },
    handleSubmit(form, scenic_id) {
      if (this.submitType === 1) {
        scenic.addScenic.r(form).then(res => {
          this.chushihua("创建成功");
        });
      } else if (this.submitType === 2) {
        console.log("修改成功", form);
        scenic.editScenic.r(form).then(res => {
          this.chushihua("修改成功");
        });
      } else if (this.submitType === 3) {
        form["scenic_id"] = this.scenic_id;
        scenic.addScenicInfo.r(form).then(res => {
          this.chushihua("设置基础信息成功");
        });
      }
    },
    chushihua(text) {
      if (text) this.$message.success(text);
      this.formData = {};
      this.dialogFormVisible = false;
      this.getlist();
    },
    handleSuccess() {},
    // 删除
    delBtn(form) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          scenic.deleteScenic.r({ scenic_id: form.scenic_id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getlist();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //   多选
    handleSelectionChange(e) {},
    // 筛选条件
    searchSubmit(e) {
      this.searchData = e;
      if (e) {
        this.page.currentPage = 1;
      }
      this.getlist();
    },
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    // 分页器
    refreshChange(e) {
      let that = this;
      setTimeout(() => {
        this.getlist();
      }, 1000);
    },
    getlist(e) {
      let param;
      let that = this;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      scenic.getScenic.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
      });
    }
  }
};
</script>
